// extracted by mini-css-extract-plugin
export default {"confetti":"confetti_confetti__TLw2d","confettiPiece":"confetti_confettiPiece__NopYI","makeItRain":"confetti_makeItRain__gyGyn"};